import { useState } from 'react'

import qs from 'qs'

import { LoadingContainer, Pagination, Panels, Bar } from 'peach/components'
import { ListSubroutes, useParams } from 'peach/router'

import { useQueryString } from 'core/hooks'
import { Page } from 'core/components'
import { PickRequired, useInternalListTemplateVersionsModern } from 'core/types'
import { InternalListTemplateVersionsModernVariables } from 'core/types/operations'
const CompanyTemplatesRoutes = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const [page, setPage] = useState(1)

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<InternalListTemplateVersionsModernVariables['query']>,
      'limit' | 'startingAfter' | 'endingBefore'
    >
  >({
    limit: 50,
    startingAfter: undefined,
    endingBefore: '',
  })

  const {
    data: templates,
    pagination: { total: count, nextUrl, previousUrl } = {},
    isLoading,
    error,
  } = useInternalListTemplateVersionsModern({
    companyId,
    query,
  })

  const nextTemplate = qs.parse(nextUrl ?? '')?.startingAfter
  const previousTemplate = qs.parse(previousUrl ?? '')?.endingBefore

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              onNext={() => {
                setQuery({
                  ...query,
                  startingAfter: nextTemplate,
                  endingBefore: '',
                })
                setPage(page + 1)
              }}
              onPrevious={() => {
                setQuery({
                  ...query,
                  startingAfter: undefined,
                  endingBefore: page > 2 ? previousTemplate : '',
                })
                setPage(page - 1)
              }}
              page={page}
              total={count}
              variant='compact'
            />
          }
          title='Templates'
        />
      }
    >
      <LoadingContainer error={error} isLoading={isLoading}>
        <Page variant='full'>
          <ListSubroutes
            json={templates}
            paramKey='templateId'
            title='Templates'
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyTemplatesRoutes
